export const en = {
    Navigation: {
        me: {
            label: "Me",
            description: "Your profile"
        }
    },
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Jump to",
        openNavigation: "Open navigation",
        closeNavigation: "Close navigation",
        primaryNavigation: "Primary",
        openUserMenu: "Open workspace and user menu",
        accountSettings: "Personal settings",
        organizationSettings: "Organization settings",
        workspace: "Workspace",
        currentWorkspace: "Current workspace",
        switchWorkspaceError: "Couldn't switch workspace. Please try again.",
        loadingWorkspaces: "Loading workspaces",
        switchingWorkspace: "Switching workspace",
        logout: "Log out",
        helpCenter: "Help center",
        helpCenterUrl: "https://help.workleap.com/en/collections/19772749-the-new-workleap",
        opensInNewTab: "opens in a new tab",
        takeTheTour: "Take the tour",
        resizeAgentPanel: "Resize agent panel",
        skipToMainContent: "Skip to main content"
    },
    AssistantTabIndicator: {
        working: "Working…",
        done: "Done",
        error: "Error"
    },
    CreateMenu: {
        create: "Create",
        newSurvey: "New survey",
        newReviewCycle: "New review cycle",
        newPlan: "New plan"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Close menu"
    },
    TabsLayout: {
        tabs: "Tabs"
    },
    SectionMenuTrigger: {
        openMenu: "{{title}}, open menu"
    },
    ModuleErrorBoundary: {
        title: "Something went wrong",
        description: "We couldn't load this page. You can try again, or head back home.",
        retry: "Try again",
        goHome: "Go home"
    },
    NotFoundPage: {
        title: "Page not found",
        code: "404",
        description: "This page could not be found.",
        backHome: "Back to home"
    },
    OrganizationAccessPage: {
        title: "Not available",
        heading: "Not available for your organization yet",
        body: "Your organization doesn't have access to the new Workleap experience. You can keep using the classic Workleap experience.",
        backToWorkleap: "Back to Workleap"
    },
    RootErrorBoundary: {
        title: "Something went wrong",
        description: "The application could not start. Try refreshing the page or returning to the home page.",
        goHome: "Go home"
    },
    BootstrappingRoute: {
        loading: "Loading"
    },
    unmanagedMutationErrors: {
        toastMessage: "Something went wrong. Please try again."
    },
    CommandMenu: {
        placeholder: "Jump to",
        noResults: "No results match your search.",
        searching: "Searching...",
        dialogLabel: "Command palette",
        searchLabel: "Quick search",
        sections: {
            people: "People",
            teams: "Teams"
        },
        memberCount_one: "{{count}} member",
        memberCount_other: "{{count}} members",
        footer: {
            navigate: "navigate",
            open: "open",
            escToClose: "esc to close"
        }
    },
    ProductTour: {
        stepCounter: "{{current}} of {{total}}",
        skip: "Skip tour",
        back: "Back",
        next: "Next",
        done: "Done",
        stepAnnouncement: "Step {{current}} of {{total}}: {{title}}"
    },
    OnboardingProductTour: {
        agent: {
            title: "Never start from scratch again",
            body: "Ask anything, from any page. Your agent drafts 1:1 agendas, replies, and reviews from your team's data, ready for you to edit."
        },
        navigation: {
            title: "Always know where to look",
            bodyIndividual: "See your own work and the whole organization's without switching tools. Goals and Good Vibes are at both levels.",
            bodyTeam: "See your own work, your team's, and the whole organization's without switching tools. Goals and Good Vibes are at every level."
        },
        shortcuts: {
            title: "Go straight to it",
            body: "Press {{shortcut}} and type a name or page instead of digging through menus. Use + to send Good Vibes or create a goal from any page."
        },
        analytics: {
            title: "Help every team thrive",
            body: "Compare how teams are doing to see where your support will make the biggest difference."
        },
        restart: {
            title: "Come back anytime",
            body: "Choose “Take the tour” in your profile menu whenever you want a refresher."
        }
    }
};
